module.exports = __webpack_public_path__ + "img/logo-circle.a3ed432d.svg";